import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { autoFillAddress } from "../slices/fillAddressSlice"

const types = {
  extNumber: 'street_number',
  street: 'route',
  colony: 'political',
  city: 'locality',
  state: 'administrative_area_level_1',
  country: 'country',
  postal_code: 'postal_code'
}
export const useSplitAddress = ( ) => {
  const [newData, setNewData] = useState({})
  const [coors, setCoors] = useState({})
  const dispatch = useDispatch()
  let newAddress = {}

  const switchData = (type, value) => {
    switch (type) {
      case types.extNumber:
        newAddress = { ...newAddress, extNumber: value }
        setNewData(newAddress)
        break;
      case types.street:
        newAddress = { ...newAddress, street: value }
        setNewData(newAddress)
        break;
      case types.colony:
        newAddress = { ...newAddress, colony: value }
        setNewData(newAddress)
        break;
      case types.city:
        newAddress = { ...newAddress, city: value }
        setNewData(newAddress)
        break;
      case types.state:
        newAddress = { ...newAddress, state: value }
        setNewData(newAddress)
        break;
      case types.country:
        newAddress = { ...newAddress, country: value }
        setNewData(newAddress)
        break;
      case types.postal_code:
        newAddress = { ...newAddress, postalCode: value }
        setNewData(newAddress)
        break;

      default: return newAddress
    }
  }
  const sortData =  (data) => {
    const { address_components, geometry } = data && data
    setCoors({
      lat: geometry.location.lat(),
      lng: geometry.location.lng(),
    })
    return address_components?.map((item) => {
      
    // setNewData(switchData(item.types[0], item.long_name ))
      return  switchData(item.types[0], item.long_name )
    })

  }




  

  useEffect(() => {
    dispatch(autoFillAddress({...newData, ...coors}))
    setNewData(newData)
  }, [newData])

  return { sortData, newData }
}